// extracted by mini-css-extract-plugin
module.exports = {"actionCard-container":"actionCard_actionCard-container__24uJU","actionCard-title":"actionCard_actionCard-title__21kk7","actionCard-img":"actionCard_actionCard-img__QMep5"};